import React, { useEffect, useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import Button from "../../../../components/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddArea from "./hooks/useAddArea";
import useUpdateArea from "./hooks/useUpdateArea";
import useArea from "./hooks/useArea";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import SelectInput from "../../../../components/SelectInput";
import CustomLoader from "../../../../components/CustomLoader";
import useTerritoryOptions from "./hooks/useTerritoryOptions";
import {
  addStateArea,
  editStateArea,
  setFilterTextArea,
  setCheckStatusStateArea,
  rowForEditStateArea,
  disableButtonStateArea,
  selectedRowsStateArea,
  rowEditIdStateArea,
  setLinkStateArea,
  setButtonLinkTextStateArea,
  setHierarchyIdStateArea,
  setHiddenColumnStateArea,
  setDescriptionAreaState,
} from "../../OfficeHierarchy/Area/atoms/atoms";
import { useHistory } from "react-router-dom";
import { getHierarchyType } from "../../OfficeHierarchy/Area/atoms/atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS, FIELDPERMISSIONS } from "../../../PermissionsConstants";

const AreaForm = ({ employeeList }) => {
  //Hooks
  const AddArea = useAddArea();
  const UpdateArea = useUpdateArea();
  const data = useArea();
  const history = useHistory();
  //Field permissions
  const contactPermission =
    FIELDPERMISSIONS.fieldpermission_officehierarchy_contact;
  const userPermissions = useRecoilValue(permissionsSelector);
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateArea);
  const [actionEditState, setActionEditState] = useRecoilState(editStateArea);
  const [filterText, setFilterText] = useRecoilState(setFilterTextArea);
  const [rowForEdit, setRowForEdit] = useRecoilState(rowForEditStateArea);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsStateArea);
  const [editRowId, setEditRowId] = useRecoilState(rowEditIdStateArea);
  const [checkStatus, setCheckStatus] = useRecoilState(setCheckStatusStateArea);
  const [disabledButton, setDisabledButton] = useRecoilState(
    disableButtonStateArea
  );
  const [type, setType] = useRecoilState(getHierarchyType);
  const [hideColumn, sethideColumn] = useRecoilState(setHiddenColumnStateArea);
  const userAccount = useRecoilValue(accountAtom);
  const [hierarcyId, setHierarchyId] = useRecoilState(setHierarchyIdStateArea);
  const [buttonLinkState, setButtonLinkState] =
    useRecoilState(setLinkStateArea);
  const [buttonTextLinkState, setButtonTextLinkState] = useRecoilState(
    setButtonLinkTextStateArea
  );
  const [description] = useRecoilState(setDescriptionAreaState);
  //Local States
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasArea, setHasArea] = useState(false);
  const [areaExist, setAreaExist] = useState(false);
  const [emptypeIsExistState, setEmpTypeIsExistState] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openTerritoryModal, setOpenTerritoryModal] = useState(false);
  const territoryOptions = useTerritoryOptions()
    ?.filter((x) => x.isActive)
    .map((x) => {
      return {
        label: x.territoryCode + " - " + x.territoryName,
        value: x.territoryId,
      };
    });
  const defaultTerritory = useTerritoryOptions()
    ?.filter((x) => x.territoryId === rowForEdit.territoryId)
    .map((x) => {
      return {
        label: x.territoryCode + " - " + x.territoryName,
        value: x.territoryId,
      };
    });
  const employeeOptions = employeeList
    ?.filter((x) => x.status !== "Terminated")
    .map((x) => {
      return {
        label: x.employeenumber + " - " + x.fullname,
        value: x.employeenumber,
        email: x.email,
        empNo: x.employeenumber,
        fullname: x.fullname,
      };
    });
  const defaultEmployee = employeeList
    ?.filter((x) => x.fullname === rowForEdit.areaManager)
    .map((x) => {
      return {
        label: x.employeenumber + " - " + x.fullname,
        value: x.employeenumber,
        email: x.email,
        empNo: x.employeenumber,
        fullname: x.fullname,
      };
    });

  const defaulValues = {
    areaId: 0,
    areaCode: "",
    areaName: "",
    areaManager: "",
    managerEmail: "",
    managerUltiproNumber: "",
    territoryId: 0,
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
    isActive: 0,
  };
  const defaultEditValues = {
    areaId: rowForEdit.areaId,
    areaCode: rowForEdit.areaCode,
    areaName: rowForEdit.areaName,
    areaManager: rowForEdit.areaManager,
    managerEmail: rowForEdit.managerEmail,
    managerUltiproNumber: rowForEdit.managerUltiproNumber,
    territoryId: rowForEdit.territoryId,
    updatedBy: "",
    updatedOn: null,
    isActive: rowForEdit.isActive,
  };
  const [addNewData] = useState([defaulValues]);
  const [editData] = useState([defaultEditValues]);
  const [managerEmail, setManagerEmail] = useState(
    actionEditState
      ? defaultEmployee?.length === 0
        ? ""
        : rowForEdit.managerEmail
      : addNewData.managerEmail
  );
  const [managerUltiproNumber, setManagerUltiproNumber] = useState(
    actionEditState
      ? defaultEmployee?.length === 0
        ? ""
        : rowForEdit.managerUltiproNumber
      : addNewData.managerUltiproNumber
  );

  const handleAddArea = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setAreaExist(false);
    inputvalue =
      fieldName === "territoryId" || fieldName === "areaManager"
        ? inputvalue
        : inputvalue.trim();
    if (SourceType === "addArea") {
      if (fieldName === "salesforceId") {
        addNewData.map((x) => (x.salesforceId = inputvalue));
      }
      if (fieldName === "areaCode") {
        addNewData.map((x) => (x.areaCode = inputvalue));
      }
      if (fieldName === "areaName") {
        addNewData.map((x) => (x.areaName = inputvalue));
      }
      if (fieldName === "areaManager") {
        setManagerEmail(inputvalue === null ? "" : inputvalue.email);
        setManagerUltiproNumber(inputvalue === null ? "" : inputvalue.empNo);
        addNewData.map(
          (x) =>
            (x.areaManager = inputvalue === null ? "" : inputvalue.fullname)
        );
        addNewData.map(
          (x) => (x.managerEmail = inputvalue === null ? "" : inputvalue.email)
        );
        addNewData.map(
          (x) =>
            (x.managerUltiproNumber =
              inputvalue === null ? "" : inputvalue.empNo)
        );
      }
      if (fieldName === "territoryId") {
        addNewData.map((x) => (x.territoryId = inputvalue));
      }
    }
    if (
      addNewData[0].areaName !== "" &&
      addNewData[0].areaCode !== "" &&
      addNewData[0].territoryId !== 0 &&
      !userPermissions.includes(contactPermission)
    ) {
      setHasArea(true);
    } else if (
      addNewData[0].areaName !== "" &&
      addNewData[0].areaCode !== "" &&
      addNewData[0].territoryId !== 0 &&
      addNewData[0].areaManager !== "" &&
      userPermissions.includes(contactPermission)
    ) {
      setHasArea(true);
    } else {
      setHasArea(false);
    }
    addNewData.map((x) => (x.createdOn = new Date().toISOString()));
    addNewData.map((x) => (x.createdBy = userAccount.username));
    addNewData.map((x) => (x.isActive = true));
  };

  //save changes
  const handleSaveAdd = (addNewData) => {
    if (changed) {
      if (!areaExist) {
        if (addNewData.filter((x) => x.areaName) !== "") {
          //call Insert
          AddArea(addNewData);
          if (buttonLinkState) {
            setTimeout(() => {
              handleLink();
            }, 3000);
          }
          setOpenModal(false);
        } else {
          toast.fire("Failed", "Please populate fields!", "error");
          setOpenModal(false);
        }
      } else {
        toast.fire("Failed", "The data already exists!", "error");
        setOpenModal(false);
      }
    } else {
      toast.fire("Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  // end of saving changes

  const handleCheckBox = (checked) => {
    if (
      editData[0].areaName !== "" &&
      editData[0].areaCode !== "" &&
      editData[0].areaManager !== "" &&
      editData[0].territoryId !== 0
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? editData.map((x) => (x.isActive = true))
      : editData.map((x) => (x.isActive = false));
    editData.map((x) => (x.updatedOn = new Date().toISOString()));
    editData.map((x) => (x.updatedBy = userAccount.username));
  };

  const handleEditFieldsChange = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setAreaExist(false);
    inputvalue =
      fieldName === "territoryId" || fieldName === "areaManager"
        ? inputvalue
        : inputvalue.trim();
    if (SourceType === "editArea") {
      if (fieldName === "salesforceId") {
        editData.map((x) => (x.salesforceId = inputvalue));
      }
      if (fieldName === "areaCode") {
        editData.map((x) => (x.areaCode = inputvalue));
      }
      if (fieldName === "areaName") {
        editData.map((x) => (x.areaName = inputvalue));
      }
      if (fieldName === "areaManager") {
        setManagerEmail(inputvalue === null ? "" : inputvalue.email);
        setManagerUltiproNumber(inputvalue === null ? "" : inputvalue.empNo);
        editData.map(
          (x) =>
            (x.areaManager = inputvalue === null ? "" : inputvalue.fullname)
        );
        editData.map(
          (x) => (x.managerEmail = inputvalue === null ? "" : inputvalue.email)
        );
        editData.map(
          (x) =>
            (x.managerUltiproNumber =
              inputvalue === null ? "" : inputvalue.empNo)
        );
      }
      if (fieldName === "territoryId") {
        editData.map((x) => (x.territoryId = inputvalue));
      }
    }
    if (
      editData[0].areaName !== "" &&
      editData[0].areaCode !== "" &&
      editData[0].areaManager !== "" &&
      editData[0].territoryId !== 0
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
    editData.map((x) => (x.updatedOn = new Date().toISOString()));
    editData.map((x) => (x.updatedBy = userAccount.username));
  };

  //Save changes
  const handleSaveEdit = (editData) => {
    if (changed) {
      if (!areaExist) {
        if (editData.filter((x) => x.areaName) !== "") {
          UpdateArea(editData);
          setOpenModalEdit(false);
          if (!actionEditState) {
            setEditRowId([]);
            setSelectedRows([]);
            setEmpTypeIsExistState(false);
            setChanged(false);
            setDisabledButton(false);
            sethideColumn(false);
          }
        } else {
          toast.fire("Failed", "All fields must be filled!", "error");
          setOpenModalEdit(false);
        }
      } else {
        toast.fire("Failed", "Area already exists!", "error");
        setOpenModalEdit(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditRowId([]);
      setOpenModalEdit(false);
      setChanged(false);
      setActionEditState(false);
      setDisabledButton(false);
    }
  };
  // end of saving changes
  const handleLink = () => {
    history.push({
      pathname: "/carrieragreementmgmt/officehierarchy",
      state: {
        recordId: buttonTextLinkState !== "Add" ? hierarcyId + " " : " ",
        moduleName: "Office Hierarchy",
        subModuleName: buttonTextLinkState,
        selectedType: type,
        description: description,
      },
    });
    window.location.reload();
  };
  return (
    <div>
      {territoryOptions && employeeOptions && defaultEmployee ? (
        <div className="w-full">
          <div className="p-3 py-2 space-y-1 border-l-6  rounded-l-xl rounder-r-none box-shadow mt-2 ">
            <div className="flex w-full ">
              <div className="text-base text-primary font-bold w-full">
                {actionAddState ? "Add New Area" : "Edit: "}
                {actionAddState ? (
                  ""
                ) : (
                  <div className="italic">{rowForEdit.areaName}</div>
                )}
              </div>
              <div className="flex items-center justify-end space-x-2 w-full">
                <Button
                  className={`flex items-right shadow-md text-xs font-semibold text-white justify-right gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${
                actionAddState
                  ? !hasArea
                  : !changed
                  ? "opacity-50"
                  : "opactiy-100"
              }`}
                  disabled={actionAddState ? !hasArea : !changed}
                  onClickFunction={() =>
                    actionAddState ? setOpenModal(true) : setOpenModalEdit(true)
                  }
                >
                  <CheckCircleIcon className="h-4 w-4" />
                  <div className=" self-center -mt-px">Save</div>
                </Button>
                <Button
                  className="flex items-right text-xs shadow-md font-semibold text-white justify-right gap-x-1 rounded-full bg-octonary bg-transparent hover:bg-octonary px-2 py-1 "
                  onClickFunction={() => {
                    if (buttonLinkState) {
                      handleLink();
                    } else {
                      setActionAddState(false);
                      setActionEditState(false);
                      setDisabledButton(false);
                      setFilterText("");
                      setManagerEmail("");
                      setManagerUltiproNumber();
                      sethideColumn(false);
                      setEditRowId([]);
                    }
                  }}
                >
                  <XCircleIcon className="h-4 w-4" />
                  <div className=" self-center -mt-px">Cancel</div>
                </Button>
              </div>
            </div>
            <div className="mt-2 h-1 w-full border-b-4 border-secondary "></div>
            <div className="italic text-secondary text-xs3">
              <b> Note: </b> All fields with * are required to fill
            </div>
            <div className="w-full -mx-2">
              {/* firstrow */}
              <div className="text-xs font-medium ">
                <div className="grid  grid-cols-2 w-full  gap-5 m-2 ">
                  <div className="grid grid-cols-3">
                    <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                      Area Name: <span className="text-red-500">*</span>
                    </label>
                    <div className="">
                      <TextInput
                        defaultValue={
                          actionEditState
                            ? rowForEdit.areaName
                            : addNewData.areaName
                        }
                        onChange={(e) =>
                          !actionEditState
                            ? handleAddArea(
                                "addArea",
                                "areaName",
                                e.target.value
                              )
                            : handleEditFieldsChange(
                                "editArea",
                                "areaName",
                                e.target.value
                              )
                        }
                      />
                    </div>
                  </div>
                  {userPermissions.includes(contactPermission) ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                        Area Manager: <span className="text-red-500">*</span>
                      </label>
                      <div className="">
                        <SelectInput
                          defaultValue={
                            actionEditState
                              ? defaultEmployee
                              : addNewData.areaManager
                          }
                          options={employeeOptions ? employeeOptions : []}
                          onChange={(e) =>
                            !actionEditState
                              ? handleAddArea(
                                  "addArea",
                                  "areaManager",
                                  e === null ? null : e
                                )
                              : handleEditFieldsChange(
                                  "editArea",
                                  "areaManager",
                                  e === null ? null : e
                                )
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* 2ndrow */}
                <div className="grid  grid-cols-2 w-full  gap-5  m-2">
                  <div className="grid grid-cols-3">
                    <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                      Area Code: <span className="text-red-500">*</span>
                    </label>
                    <div className="">
                      <TextInput
                        defaultValue={
                          actionEditState
                            ? rowForEdit.areaCode
                            : addNewData.areaCode
                        }
                        onChange={(e) =>
                          !actionEditState
                            ? handleAddArea(
                                "addArea",
                                "areaCode",
                                e.target.value
                              )
                            : handleEditFieldsChange(
                                "editArea",
                                "areaCode",
                                e.target.value
                              )
                        }
                      />
                    </div>
                  </div>
                  {userPermissions.includes(contactPermission) ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                        Manager Email:
                      </label>
                      <div className="opacity-50">
                        <TextInput
                          value={managerEmail}
                          type="email"
                          disabled={true}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* 3rdrow */}
                <div className="grid  grid-cols-2 w-full gap-5 m-2">
                  <div className="grid grid-cols-3">
                    <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                      Territory: <span className="text-red-500">*</span>
                    </label>
                    <div className="">
                      <SelectInput
                        defaultValue={
                          actionEditState
                            ? defaultTerritory
                            : addNewData.territoryId
                        }
                        options={territoryOptions ? territoryOptions : []}
                        onChange={(e) =>
                          !actionEditState
                            ? handleAddArea(
                                "addArea",
                                "territoryId",
                                e === null ? 0 : e.value.toString()
                              )
                            : handleEditFieldsChange(
                                "editArea",
                                "territoryId",
                                e === null ? 0 : e.value.toString()
                              )
                        }
                      />
                    </div>
                  </div>
                  {userPermissions.includes(contactPermission) ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                        Manager Ultipro Number:
                      </label>
                      <div className="opacity-50">
                        <TextInput
                          value={managerUltiproNumber}
                          disabled={true}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* 4throw */}
                <div className="grid  grid-cols-2 w-full  gap-5 m-2">
                  {!actionAddState ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700  text-right mr-2">
                        Active:
                      </label>
                      <div className="flex justify-left space-x-1 cursor-pointer">
                        <input
                          type="checkbox"
                          className="flex items-left space-x-1 cursor-pointer"
                          defaultChecked={rowForEdit.isActive}
                          onClick={(e) => {
                            handleCheckBox(e.target.checked);
                          }}
                        />
                        <label
                          className="cursor-pointer text-green-600 text-xs"
                          name="Status"
                        >
                          {checkStatus
                            ? "Uncheck to Deactivate"
                            : "Check to Activate"}
                        </label>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="grid  grid-cols-3  gap-5 m-2"></div>
              </div>
            </div>
          </div>
          <ConfirmBoxModal
            ModalTitle="Add Area"
            qConfirmation=" Are you sure you want to add this?"
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            onClickFunction={() => {
              handleSaveAdd(addNewData);
            }}
          />
          <ConfirmBoxModal
            ModalTitle="Update Area"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => setOpenModalEdit(false)}
            onClickFunction={() => {
              handleSaveEdit(editData);
            }}
          />

          <div className="hidden sm:block" aria-hidden="true">
            <div className="py-2"></div>
          </div>
        </div>
      ) : (
        <div className="h-96">
          <CustomLoader />
        </div>
      )}
    </div>
  );
};

export default AreaForm;
